import React, { useState, useEffect, useCallback, useRef } from "react";
import { connect } from "react-redux";
import "../../css/salesorder.css";
import { createStore } from 'devextreme-aspnet-data-nojquery';
import { GetFormatedDateWithTime } from '../../../common/Utils';
import AccordionReact from 'devextreme-react/accordion';
import FormField from '../../../dynamicFormBuilder/FormField';
import SearchFormLayout from './SearchFormLayout';
import Toolbar, { Item } from "devextreme-react/toolbar";
import { Button } from 'devextreme-react/button';
import data from "../../../assets/apiRoutes.json";
import {
    GetLookupData
} from "../../../om/services/SalesOrderService";
import SalesOrderSearchResult from "./SearchResults";
const searchpanel = [
    {
        ID: 1,
        Title: 'Search Filters'
    }
];
const AllocateAvailableQuantities = (props) => {
    const [selectedItems, setSelectedItems] = useState([]);
    var accessToken = props.oidc.user.access_token;
    var currentUser = props.oidc.user;
    const DYNAMICFORMSETTING = props.oidc?.user?.profile?.DYNAMICFORMSETTING;
    const formRefs = useRef({});
    const initialFormFields = {
        TransactionDateFrom: '',
        TransactionDateTo: '',
        TRANSACTIONNUMBER: '',
        R_CUSTOMER: '',
        R_Item: '',
        R_Warehouse: '',
        R_Lot: '',
    };
    const [formFields, setformFields] = useState(initialFormFields);
    const handleFormSubmit = async (e) => {
        e.preventDefault();
        searchData(formFields);
    };
    const selectionChanged = useCallback(
        (e, tg) => {
            let newItems = [...selectedItems];
            e.removedItems.forEach((item) => {
                const index = newItems.indexOf(item);
                if (index >= 0) {
                    newItems.splice(index, 1);
                }
            });
            if (e.addedItems.length) {
                newItems = [...newItems, ...e.addedItems];
            }
            setSelectedItems(newItems);
            searchPanelData((prevStatus) => {
                const newStatus = !prevStatus;
                return newStatus;
            });
        },
        [selectedItems, setSelectedItems],
    );
    const handleReset = (e) => {
        e.event.stopPropagation();
        setformFields(initialFormFields);
    };
    const getCustomerUrl = "om/Processing/GetCustomers";
    const getItemsUrl = "om/Item/GetItemsByCustomer";
    const getLotsUrl = "om/Lot/GetLotsByItem/";
    const getwarehouseUrl = "om/Processing/GetWareHouses";
    const handleFieldChange = useCallback((name, value) => {
        console.log(name);
        console.log(value);
        if (name == "R_Item") {
            const fullUrl = `${getLotsUrl}?itemid=${value}`;
            GetLookupData("R_Lot", fullUrl, accessToken, formRefs, formRefs, setForceRender, forceRender);
        }
    }, []);
    const [forceRender, setForceRender] = useState(false);
    const orderStatus = '0';
    const getSalesOrderUrl = "om/SaleOrder/SalesOrderSearch";
    const [dataSource, setDataSource] = useState(null);
    var accessToken = props.oidc.user.access_token;
    const [searchPanelStatus, setSearchPanelStatus] = useState(false);
    const searchPanelData = (resultData) => {
        setSearchPanelStatus(resultData);
    };
    const searchData = (formFields) => {
        GetSalesOrderGridData(formFields);
    };
    const GetSalesOrderGridData = (formFields) => {
        const detailDataSource = createStore({
            key: 'rowid',
            loadParams:
            {
                TransactionDateFrom: function () {
                    return GetFormatedDateWithTime(formFields?.TransactionDateFrom);
                },
                TransactionDateTo: function () {
                    return GetFormatedDateWithTime(formFields?.TransactionDateTo);
                },
                Transactionnumber: function () {
                    return formFields?.TRANSACTIONNUMBER;
                },
                RItem: function () {
                    return formFields?.R_Item;
                }, R_CUSTOMER: function () {
                    return formFields?.R_CUSTOMER;
                }, R_Warehouse: function () {
                    return formFields?.R_Warehouse;
                }, R_Lot: function () {
                    return formFields?.R_Lot;
                },
            },
            loadUrl: `${window._env_.REACT_APP_APIS}/${data.OM.SearchTransactionsDetails}`,
            updateUrl: `${window._env_.REACT_APP_APIS}/${data.OM.AllocateAvailableQuantities}`,
            onBeforeSend: function (method, ajaxOptions) {
                ajaxOptions.headers = {
                    access_token: accessToken,
                    Authorization: `Bearer ${accessToken}`,
                };
                if (method === 'update') {
                    ajaxOptions.data = ajaxOptions.data || {};
                    ajaxOptions.headers.key = ajaxOptions.data.key ?? "";
                }
            }
        });
        setDataSource(detailDataSource);
    }
    const handleSalesOrderSearchFormLoad = useCallback(() => {
        GetLookupData("R_CUSTOMER", getCustomerUrl, accessToken, formRefs, formRefs, setForceRender, forceRender);
        GetLookupData("R_Item", getItemsUrl, accessToken, formRefs, formRefs, setForceRender, forceRender);
        GetLookupData("R_Warehouse", getwarehouseUrl, accessToken, formRefs, formRefs, setForceRender, forceRender);
    }, []);
    useEffect(() => {
        //searchData(formFields);
    }, []);
    return (
        <div>
            <div className="row">
                <div className="col-md-12 main-page">
                    <div id="accordion" >
                        <form onSubmit={(e) => handleFormSubmit(e)}>
                            <AccordionReact
                                dataSource={searchpanel}
                                collapsible={true}
                                multiple={false}
                                animationDuration={300}
                                selectedItems={selectedItems}
                                onSelectionChanged={e => {
                                    if (e.currentTarget === e.target) {
                                        selectionChanged(e, e.target);
                                    }
                                }}
                                itemTitleRender={() => (
                                    <Toolbar className="accordian-toolbar">
                                        <Item location="before">
                                            <div className="title">
                                                <h6
                                                    style={{
                                                        color: window._env_.Color2
                                                    }}
                                                >
                                                    Allocate Available Quantities
                                                </h6>
                                            </div>
                                        </Item>

                                        <Item location="after">
                                            <Button className="accordianButton" useSubmitBehavior={true} onClick={(e)=>e.event.stopPropagation()} text="Search" type="default" />
                                        </Item>
                                        <Item location="after">
                                            <Button className="accordianButton" onClick={handleReset} text="Reset" />
                                        </Item>
                                    </Toolbar>
                                )}
                                itemRender={(itemProps) => (
                                    <div>
                                        <FormField
                                            currrentUser={currentUser}
                                            layoutId='38213ad0-a31c-480c-93d5-7a8026ded5d4'
                                            layoutName='MyTestForm3333'
                                            defaultFormSchema={SearchFormLayout}
                                            formFields={formFields}
                                            setformFields={setformFields}
                                            handleFieldValueChange={handleFieldChange}
                                            DYNAMICFORMSETTING={DYNAMICFORMSETTING}
                                            formRefs={formRefs}
                                            onFormLoad={handleSalesOrderSearchFormLoad}
                                            noSpacingBeforeFirstRow={true}
                                        />

                                    </div>
                                )}
                                id="accordion-container" className="accordion-height"
                            />
                        </form>
                        <SalesOrderSearchResult searchPanelStatus={searchPanelStatus} data={dataSource} accessToken={accessToken} />
                    </div>
                </div>
            </div>
        </div>
    );
};
function mapStateToProps(state) {
    return {
        ReceiptReducer: state.ReceiptReducer,
        oidc: state.oidc,
    };
}
export default connect(mapStateToProps)(AllocateAvailableQuantities);